// extracted by mini-css-extract-plugin
module.exports = {"mouseFollower":"MouseFollower_mouseFollower__xV9cD","dot":"MouseFollower_dot__kDHMs","label":"MouseFollower_label__lFr_G","arrow":"MouseFollower_arrow__xklmb"};